import { render } from "./clue.vue?vue&type=template&id=142fd5be&scoped=true"
import script from "./clue.vue?vue&type=script&lang=js"
export * from "./clue.vue?vue&type=script&lang=js"

import "./clue.vue?vue&type=style&index=0&id=142fd5be&scoped=true&lang=css"
import "./clue.vue?vue&type=style&index=1&id=142fd5be&lang=css"
script.render = render
script.__scopeId = "data-v-142fd5be"

export default script